import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useMemo } from "react";
import { RSForm } from "../index";
import countryList from "react-select-country-list";
import { SingleSelect } from "./index";
function CountrySelect(props) {
    const { label, value, setValue } = props;
    const countryOptions = useMemo(() => countryList().getData(), []);
    const countryItems = countryOptions.map((item) => item.label);
    return (_jsxs(RSForm.Group, { controlId: "formCountrySelector", children: [_jsx(RSForm.ControlLabel, { children: label ?? "Nationality:" }), _jsx(SingleSelect, { data: countryItems, placeholder: "Please Select...", value: value, setValue: setValue, block: true })] }));
}
export default CountrySelect;
